import React, {useMemo} from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "../../UI/Grid";
import { IntegrationTableHead } from "./IntegrationTableHead";
import { IntegrationTableBody } from "./IntegrationTableBody";
import { IntegrationTableEntrataHead } from "./IntegrationTableEntrataHead";
import { IntegrationTableEntrataBody } from "./IntegrationTableEntrataBody";
import { IntegrationTableKineticHead } from "./IntegrationTableKineticHead";
import { IntegrationTableKineticBody } from "./IntegrationTableKineticBody";
import useAuth from "../../routes/login/AuthContext";
import { useIntegrationContext } from "../IntegrationTable/IntegrationProvider";

import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import { EnhancedTable } from "../EnhancedTable";
import { PageTablePagination } from "../PageTablePagination";

interface IProps {
  showArchived?: boolean;
  showAll?: boolean;
}

const DISABLED_IMPORT_TEXT = "Import for this network is currently disabled. No residents are being imported or invited at this time.  To change this setting, please contact the RoomSync team at acc@roomsync.com.";

export const IntegrationTable: React.FC<IProps> = ({showArchived, showAll}) => {
  const { isSuperAdmin } = useAuth();
  const { isEntrata, isKinetic } = useSelectedNetworkImportTypes();
  const { accApi, importEnabled } = useIntegrationContext();
  const importDisabled = useMemo(() => !isSuperAdmin() && importEnabled === false && accApi, [importEnabled, accApi]);

  return (
    <>

      {importDisabled &&
      <Grid container mb={1} mt={-2}>
        <Grid item xs={12}>
          <Typography variant="body2"> {DISABLED_IMPORT_TEXT}</Typography>
        </Grid>
      </Grid>
      }
      <EnhancedTable>
        {!isEntrata && !isKinetic && (
          <>
            <IntegrationTableHead />
            <IntegrationTableBody showAll={showAll} />
          </>
        )}
        {isEntrata && (
          <>
            <IntegrationTableEntrataHead />
            <IntegrationTableEntrataBody showArchived={showArchived} />
          </>
        )}
        {isKinetic && (
          <>
            <IntegrationTableKineticHead />
            <IntegrationTableKineticBody showAll={showAll} />
          </>
        )}
      </EnhancedTable>
      <PageTablePagination />
    </>
  );
};
